import React, { useState, useEffect } from "react" ;

import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildResources } from "root/DataFunctions/ChildDataFns";

import ResourceCard from "../Components/UI/ResourceCard";
import Loading from "../Components/Loading";

import "../styles/Pages/games.scss";

const Games = () => {
    const [games, setGames] = useState("");

    useEffect(() => {
        getChildResources(1, (response) =>
        {
            setGames(getDataFromResponse(response));
        });
    }, []);
    return (
        <div style={{flex: "1"}}>
            <div className="child_breadcrumb child_breadcrumb-main">
                <div className="child_breadcrumb_inner">
                    <h2 className="child_breadcrumb_title">
                        Games
                    </h2>
                </div>
            </div>
            <div className="article-container">
                {games 
                    ? games.map((game) =>
                        <ResourceCard 
                            key={game.resource_id} 
                            icon_id={game.icon_id}
                            link={game.link}
                            document_id={game.document_id}
                            name={game.name}
                            description={game.description}
                        />
                    ) 
                    : <Loading />
                }
            </div>
        </div>
    );
}

export default Games;
